import React from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../styles/breakpoints";

const contextWrapper = css`
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;

  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  &:not(.visible-sm) {
    ${CSS_MQ.atMostSm} {
      display: none;
    }
  }
`;

const dotStyles = css`
  --dot-size: 8px;
  --element-size: 32px;
  ${CSS_MQ.atLeastMd} {
    --element-size: 24px;
  }

  width: var(--element-size);
  height: var(--element-size);

  cursor: pointer;

  position: relative;
  &:before {
    content: "";
    position: absolute;
    width: var(--dot-size);
    height: var(--dot-size);

    left: calc(50% - 0.5 * var(--dot-size));
    top: calc(50% - 0.5 * var(--dot-size));

    border-radius: 50%;
    background-color: ${CSS_COLORS.White};
  }

  &.active {
    &:before {
      // border: 1px solid rgba(229, 236, 234, 0.6);
      background-color: ${CSS_COLORS.Green};
    }
  }
`;

export const FamilyCarouselPagination: ReactTFC<{
  count: number;
  currentIndex: number;
  requestIndex: (idx: number) => void;
  visibleOnSmallViewports?: boolean;
  onMouseLeave?: () => void;
  onMouseOver?: () => void;
}> = props => {
  return (
    <div
      css={contextWrapper}
      className={props.visibleOnSmallViewports ? "visible-sm" : undefined}
      onMouseOver={props.onMouseOver}
      onMouseLeave={props.onMouseLeave}
    >
      {new Array(props.count).fill(undefined).map((_, idx) => {
        return (
          <span
            key={idx}
            onClick={() => props.requestIndex(idx)}
            css={dotStyles}
            className={idx === props.currentIndex ? "active" : undefined}
          />
        );
      })}
    </div>
  );
};
